import { Form } from 'antd';
import PhoneInput from 'antd-phone-input';
import { phoneValidator } from '@iso/lib/helpers/phoneHelper';

const PhoneInputFormItem = ({
  name,
  label = "Phone Number",
  placeholder = "Enter your phone number",
  className = "inputAable phoneInput",
  inputClassName = "inputFieldCstm",
  country = "au",
  required = false,
  enableSearch = true,
  disableParentheses = true,
  size = "large",
  rules = [],
  ...formItemProps
}) => {

  // Combine default validation with custom rules
  const combinedRules = [
    { validator: phoneValidator },
    ...(required ? [{ required: true, message: `${label} is required` }] : []),
    ...rules
  ];

  return (
    <Form.Item
      name={name}
      label={label}
      className={className}
      rules={combinedRules}
      {...formItemProps}
    >
      <PhoneInput
        className={inputClassName}
        size={size}
        placeholder={placeholder}
        enableSearch={enableSearch}
        disableParentheses={disableParentheses}
        country={country}
      />
    </Form.Item>
  );
};

export default PhoneInputFormItem;